import { AtSignIcon, BookTextIcon, ExternalLink, TwitterIcon } from 'lucide-react';
import type * as React from 'react';

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@/components/ui/sidebar';

export function NavInfo({ ...props }: React.ComponentPropsWithoutRef<typeof SidebarGroup>) {
  const { isMobile, setOpenMobile } = useSidebar();

  const handleLinkClick = () => {
    if (isMobile) {
      setOpenMobile(false);
    }
  };

  return (
    <SidebarGroup {...props}>
      <SidebarGroupContent>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton asChild size="sm" tooltip="Documentation">
              <a
                href="https://docs.featurebuddy.com"
                target="_blank"
                rel="noreferrer"
                onClick={handleLinkClick}
              >
                <BookTextIcon className="text-muted-foreground" />
                <span>Documentation</span>
                <ExternalLink className="ml-auto text-muted-foreground" />
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
          <SidebarMenuItem>
            <SidebarMenuButton asChild size="sm" tooltip="Twitter">
              <a
                href="https://x.com/featurebuddyhq"
                target="_blank"
                rel="noreferrer"
                onClick={handleLinkClick}
              >
                <TwitterIcon className="text-muted-foreground" />
                <span>Twitter</span>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
          <SidebarMenuItem>
            <SidebarMenuButton asChild size="sm" tooltip="Support">
              <a href="mailto:hey@featurebuddy.com" onClick={handleLinkClick}>
                <AtSignIcon className="text-muted-foreground" />
                <span>Support</span>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
